import IComponent from "components/commons/IComponent";
import DocumentTreeView from "../DocumentTreeView";
class MMReport extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      TreeView: [],
    };
  }
  async componentDidMount() {
    let cachedData = this.props.cachedData;
    if (cachedData) {
      this.setState(cachedData);
      this.props.isShowTabCallback(true);
      return;
    }
    if (this.props.text !== "") {
      let url = `${this.$config.ManMadeSlopeInfoList.MMReportUrl}`;
      let data = {
        Key: this.props.text,
      };
      var queryTexturalResults;
      try {
        queryTexturalResults = await this.fetchQueryByPOST(url, data);
      } catch {
        this.props.isShowTabCallback(false);
        return;
      }

      var treeViewResult = await queryTexturalResults.json();
      if (treeViewResult) {
        this.props.onCachePanelData(this.props.title, {
          TreeView: treeViewResult,
        });
        if (!treeViewResult.length) this.props.isShowTabCallback(false);
        else this.props.isShowTabCallback(true);
      }
      this.setState({ TreeView: treeViewResult });
    }
  }
  componentWillUnmount() {}
  render() {
    return (
      <div>
        <div className="SubPanelTitle">MM Report</div>
        <DocumentTreeView tree={this.state.TreeView} />
      </div>
    );
  }
}

export default MMReport;
